import { t } from 'ttag'

import * as h2Api from '../h2Api'

export const MAJOR_SEARCH_UPDATE = 'MAJOR_SEARCH_UPDATE'
export const SCHOOL_SEARCH_UPDATE = 'SCHOOL_SEARCH_UPDATE'
export const LOCAL_SCHOOL_SEARCH_UPDATE = 'LOCAL_SCHOOL_SEARCH_UPDATE'
export const GRADUATION_SEARCH_UPDATE = 'GRADUATION_SEARCH_UPDATE'

export const initialEditForm = {
  firstName: '',
  lastName: '',
  email: '',
  zipCode: '',
  externalId: '',
  languageId: '',
  access: null,
  localOpportunitiesAdministrator: false,
  school: null,
  major: null,
  graduationYear: null,
  userType: ''
}

export const searchMajors = text =>
  h2Api.get(`/search/suggest/majors/${encodeURIComponent(text)}`)({
    type: MAJOR_SEARCH_UPDATE
  })

export const searchSchools = text => dispatch => {
  return dispatch(
    h2Api.get(`/search/suggest/schools/${encodeURIComponent(text)}`)({
      type: SCHOOL_SEARCH_UPDATE
    })
  )
}

const graduationNames = [
  t`Senior`,
  t`Junior`,
  t`Sophomore`,
  t`Freshman`,
  t`8th Grade`,
  t`7th Grade`,
  t`6th Grade`,
  t`5th Grade`,
  t`4th Grade`,
  t`3rd Grade`,
  t`2nd Grade`,
  t`1st Grade`,
  t`Kindergarten`
]
const graduationLevels = [12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0]

export const makeGraduationLabel = graduationYear => {
  const seniorYear = dynamicValues && dynamicValues.seniorYear
  let name = `${graduationYear}`
  const offset = graduationYear - seniorYear

  if (offset >= 0 && offset < graduationNames.length) {
    name = `${name} (${graduationNames[offset]})`
  }

  return name
}

export const makeGradeFromGraduation = graduationYear => {
  const seniorYear = dynamicValues && dynamicValues.seniorYear
  const offset = graduationYear - seniorYear
  let lv = null

  if (offset >= 0) {
    lv = 12 - offset
  }

  return lv
}

export const futureGraduationOptions = (() => {
  const seniorYear = dynamicValues && dynamicValues.seniorYear
  let options = []

  for (let offset = 0; offset <= 12; offset++) {
    const gradYear = seniorYear + offset

    options = [
      ...options,
      {
        label: makeGraduationLabel(gradYear),
        value: gradYear
      }
    ]
  }

  return options
})()

export const searchGraduationYears = query => dispatch => {
  let options = futureGraduationOptions

  if (query && query.trim()) {
    options = futureGraduationOptions.filter(opt => {
      return opt.label.toLowerCase().indexOf(query.toLowerCase()) > -1
    })
  }

  dispatch({ type: GRADUATION_SEARCH_UPDATE, options })

  return options
}
